import { timetableBeta } from "@/api";
import { useEffect, useState } from "react";

export const useGetPreparedMeetingLink = ({linkToMeeting, childrenId, reportId}) => {
    const [preparedMeetingLink, setPreparedMeetingLink] = useState('');
    const [loadingPreparedMeetingLink, setLoadingPreparedMeetingLink] = useState(false);

    useEffect(() => {
        if(loadingPreparedMeetingLink) return;
        if(!linkToMeeting || !childrenId) {
            setPreparedMeetingLink('');
            return;
        }

        setLoadingPreparedMeetingLink(true)
        timetableBeta.prepareLinkToMeeting({
            userId: childrenId,
            link: linkToMeeting,
            reportId
        })
            .then(({data}) => {
                if(data?.status === 'success' && data?.link) {
                    setPreparedMeetingLink(data.link)
                }
                else{
                    setPreparedMeetingLink('')
                }
            })
            .finally(()=>setLoadingPreparedMeetingLink(false))

    }, [childrenId, linkToMeeting, reportId])

    return { preparedMeetingLink, loadingPreparedMeetingLink }
}